var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3649 11.6449C16.776 10.8035 17.9751 10.8034 18.3864 11.6448L20.6891 16.3562L25.8513 17.1129C26.7712 17.2478 27.1398 18.3769 26.4766 19.0285L22.737 22.7029L23.6195 27.8937C23.776 28.8141 22.808 29.5136 21.9833 29.0761L17.376 26.632L12.7728 29.0759C11.9484 29.5136 10.9802 28.8148 11.136 27.8945L12.0148 22.7029L8.27873 19.0281C7.61615 18.3763 7.98481 17.2478 8.90435 17.1129L14.0626 16.3563L16.3649 11.6449ZM17.3756 12.4235L15.1567 16.9643C14.9937 17.2979 14.6766 17.5296 14.3092 17.5835L9.33452 18.3132L12.9378 21.8575C13.1999 22.1152 13.3195 22.4848 13.2581 22.8473L12.4109 27.8528L16.8484 25.4969C17.1782 25.3218 17.5733 25.3217 17.9032 25.4967L22.3447 27.8528L21.4937 22.8481C21.432 22.4852 21.5518 22.115 21.8143 21.857L25.421 18.3132L20.4426 17.5834C20.0753 17.5296 19.7581 17.2979 19.5951 16.9643L17.3756 12.4235Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBig);
export default __webpack_public_path__ + "static/media/star_big.e2be806e565243772a86e3a06926db54.svg";
export { ForwardRef as ReactComponent };